import type { FaireProductEntity } from "../../entity_types/product";

export const p_6shh56wmu9: FaireProductEntity = {
  token: "p_6shh56wmu9",
  type: "product",
  name: "You Say Its Your Birthday Gourmet Popcorn",
  brandToken: "b_pffy5dqdsz",
  brandName: "Bombshell Sweets",
  imageUrl:
    "https://cdn.faire.com/fastly/768ce53c2f3f09e74df97ef3ea22fc7ec5fcd59f39d8d40a5b65276551b01620.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c8f01505c6639b9a2afc9e705da368695e1999dbced9645661c11e70171bef0.jpeg",
    "https://cdn.faire.com/fastly/47f7aa94a93cc8dc8a9a1a731972ea08e618e7bca9358caed7e1a322721d3b14.png",
  ],
  priceDollars: 5.89,
  description:
    "Celebrate every day like it’s your special day! This festive flavor captures the sweet, nostalgic taste of birthday cake with fluffy light-colored popcorn coated in creamy vanilla and dotted with colorful sprinkles. Each bite is a party for the senses — sweet, fun, and full of confetti-like crunch. Perfect for gift packs, celebrations, and anyone who believes dessert should always come first.",
  tags: [],
  msrpDollars: 11.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:26.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
